export default __webpack_public_path__ + "d0e6f39b3ec179198ac1f178b5b8170f.svg";